import { FC } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Switch
} from "@material-ui/core";
import { GenericAppThemeProperty } from "../Types";
import { useAppThemeContext } from "src/contexts/AppThemeContext";

type BehaviorPropertyCardProps = {
  property: GenericAppThemeProperty;
};

const BehaviorPropertyCard: FC<BehaviorPropertyCardProps> = ({ property }) => {
  const { updateGenericData } = useAppThemeContext();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateGenericData(property.category, property.themePropertyKey, event.target.checked.toString());
  };

  const isChecked = property.value === "true";

  return (
    <Card
      variant="outlined"
      sx={{
        transition: "all 0.2s ease-in-out",
        "&:hover": { boxShadow: 1, transform: "translateY(-1px)" },
      }}
    >
      <CardContent
        sx={{
          py: 1.5,
          px: 2,
          "&:last-child": { pb: 1.5 },
          "&:first-child": { pt: 1.5 },
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <Typography variant="subtitle2" fontWeight={600} color="primary">
            {property.propertyLabel}
          </Typography>

          <Switch
            checked={isChecked}
            onChange={handleChange}
            color="primary"
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default BehaviorPropertyCard;
